This is the current vision category {{categoryTitle}} and its description: {{categoryDescription}}.
Here is the current vision statement: {{visionStatement}}
Suggest improvements to make the vision statement clearer, more compelling, explaining why the current statement is not sufficient
